import { Spinner } from '@telegram-apps/telegram-ui';
import { AccordionCard } from '../cards';
import { useMemberStats } from '../../hooks';
import '../cards/Cards.css';

export function MemberStatsSection() {
  const { data: stats, isLoading, error } = useMemberStats();

  if (isLoading) {
    return (
      <AccordionCard icon="👥" title="По исполнителям" subtitle="Загрузка..." defaultOpen={false}>
        <div className="loading-container" style={{ padding: '20px 0' }}>
          <Spinner size="m" />
        </div>
      </AccordionCard>
    );
  }

  if (error || !stats) {
    return (
      <AccordionCard icon="👥" title="По исполнителям" subtitle="Ошибка загрузки" defaultOpen={false}>
        <div className="accordion-empty">Не удалось загрузить статистику</div>
      </AccordionCard>
    );
  }

  const total = stats.reduce((sum, s) => sum + s.count, 0);

  return (
    <AccordionCard
      icon="👥"
      title="По исполнителям"
      subtitle={`${stats.length} исполнителей, ${total} заявок`}
      defaultOpen={true}
    >
      {stats.length === 0 ? (
        <div className="accordion-empty">Нет данных</div>
      ) : (
        stats.map((stat) => (
          <div key={stat.member} className="stats-list-item">
            <span className="stats-list-item-label">{stat.member}</span>
            <span className="stats-list-item-value">{stat.count}</span>
          </div>
        ))
      )}
    </AccordionCard>
  );
}
